var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1235 11H13.7654C13.032 11 12.3286 11.2914 11.81 11.81C11.2914 12.3286 11 13.032 11 13.7654V33.1235C11 33.8569 11.2914 34.5603 11.81 35.0789C12.3286 35.5975 13.032 35.8889 13.7654 35.8889H33.1235C33.8569 35.8889 34.5603 35.5975 35.0789 35.0789C35.5975 34.5603 35.8889 33.8569 35.8889 33.1235V13.7654C35.8889 13.032 35.5975 12.3286 35.0789 11.81C34.5603 11.2914 33.8569 11 33.1235 11ZM33.1235 13.7654V33.1235H13.7654V13.7654H33.1235ZM20.679 30.358L15.1481 24.8272L17.0978 22.8637L20.679 26.4449L29.7911 17.3328L31.7407 19.2963",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/Checklist.04dd6669ad1b5bcfb002e81cb3fce794.svg";
export { ForwardRef as ReactComponent };